import * as React from 'react';
import styles from './index.less';
import { MicroApp } from 'umi';
import * as AHooks from 'ahooks';
import { FUtil } from '@freelog/tools-lib';
import FLoadingTip from '@/components/FLoadingTip';
import { initGlobalState, MicroAppStateActions } from 'qiankun';

interface Auth {
  // 所有上抛资源
  baseUpcastResources: {
    resourceID: string;
    resourceName: string;
  }[];
  // 直接依赖资源
  directDependencies: {
    id: string;
    name: string;
    type: 'resource' | 'object';
    versionRange?: string;
  }[];
  // 是否所有授权都完成
  isAllAuthComplete: boolean;
  // 操作了哪个或哪些资源引发的更新
  operations: {
    resourceID: string;
    resourceName: string;
    operation: 'add' | 'update' | 'delete';
  }[];
  // 已经签了的所有合约
  resolveResources: {
    resourceID: string;
    resourceName: string;
    contracts: {
      policyID: string;
      contractID: string;
    }[];
  }[];
  // 要排除的授权资源
  authExcludedItems: {
    resourceID: string;
    resourceName: string;
    contracts: {
      policyID: string;
      contractID: string;
    }[];
  }[];
  // 需要我主动找亮哥签的策略，比如批量创建资源那里
  batchSignContracts: {
    resourceID: string;
    resourceName: string;
    policyIDs: string[];
    subjectType: string;
  }[];
}

interface FMicroAPP_Authorization_Props {
  licenseeId: string | number;
  licenseeVersion?: string;
  mainAppType: string;
  depList: {
    id: string;
    name: string;
    type: 'resource' | 'object';
    versionRange?: string;
    applyVersions?: string[];
  }[];
  upcastList: {
    resourceID: string;
    resourceName: string;
  }[];
  autoOpenPendingDrawer?: boolean;

  mount?(data: Auth): void;

  update(data: Auth): void;
}

const state: {
  licenseeId: string;
  licenseeVersion: string;
  depList: {
    id: string;
    name: string;
    type: 'resource' | 'object';
    versionRange?: string;
    applyVersions?: string[];
  }[];
  upcastList: {
    resourceID: string;
    resourceName: string;
  }[];
} = {
  licenseeId: '',
  licenseeVersion: '',
  depList: [],
  upcastList: [],
};

const actions: MicroAppStateActions = initGlobalState(state);

function FMicroAPP_Authorization({
  licenseeId,
  licenseeVersion,
  mainAppType,
  depList,
  upcastList,
  mount,
  update,
  autoOpenPendingDrawer = false,
}: FMicroAPP_Authorization_Props) {
  const [$loading, set$loading, get$loading] = FUtil.Hook.useGetState<boolean>(true);

  AHooks.useDebounceEffect(
    () => {
      actions.setGlobalState({
        licenseeVersion: licenseeVersion,
      });
    },
    [licenseeVersion],
    {
      wait: 300,
    },
  );

  return (
    <>
      <div style={{ display: $loading ? 'none' : 'block' }}>
        <MicroApp
          name={
            self.location.host.endsWith('.testfreelog.com') ? 'Authorization_test' : 'Authorization'
          }
          licenseeId={licenseeId}
          licenseeVersion={licenseeVersion}
          mainAppType={mainAppType}
          depList={depList}
          upcastList={upcastList}
          mount={(value: any) => {
            (mount || update)?.(value);
          }}
          update={(value: any) => {
            update?.(value);
          }}
          listMounted={(done: any) => {
            set$loading(!done);
          }}
          autoOpenPendingDrawer={autoOpenPendingDrawer}
        />
      </div>
      {$loading && <FLoadingTip height={100} />}
    </>
  );
}

export default FMicroAPP_Authorization;
